<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Grupy</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="GROUP.ADD">
            <v-btn large color="error" @click="showAddModal">DODAJ GRUPĘ</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        entity-type="group"
        :headers="headers"
        :actions="actions"
        :items="list"
        :total-count="count"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
      />

      <material-dialog
        title="Potwierdź usunięcie"
        text="Czy na pewno chcesz usunąć grupę?"
        :show="!!idToDelete"
        :id="idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      />
    </material-card>

    <modal :show="showModal" :id="idToEdit" :edit="!!idToEdit" @close="hideModal" @save="add" @update="update" />
  </v-container>
</template>
<script>
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/actions';
import Modal from './modals/add.modal';

// @vuese
// Wyświetlanie listy grup
// @group groups
export default {
  mixins: [
    listMixin('groups', {
      listError: 'Wystąpił błąd podczas pobierania grup.',
      getError: 'Wystąpił błąd podczas pobierania danych grup.',
      added: 'Dodano grupę.',
      addError: 'Nie udało się dodać grupy.',
      updated: 'Zaktualizowano dane grupy.',
      updateError: 'Nie udało się zaktualizować danych grupy.',
      deleted: 'Usunięto grupę.',
      deleteError: 'Nie udało się usunąć grupy.'
    })
  ],
  components: {
    MaterialCard,
    MaterialTable,
    MaterialDialog,
    Modal,
    Search
  },
  data() {
    return {
      headers: [
        { value: 'name', text: 'Nazwa' },
        { value: 'auto', text: 'Typ' }
      ],
      actions: [DELETE_ACTION, EDIT_ACTION]
    };
  },
  computed: mapState({
    list: state =>
      state.groups.list.map(item => {
        return { name: item.name, auto: item.auto ? 'Automatyczna' : 'Manualna', id: item.id };
      })
  })
};
</script>
